/**
 * Maps DB / API `plan_name` values to stable slugs used by i18n (`pages.settings.sections.subscription.plans.*`).
 */
export type SubscriptionPlanSlug = 'free' | 'expert' | 'pro' | 'rise' | 'enterprise';

export function subscriptionPlanNameToSlug(
  planName: string | undefined | null
): SubscriptionPlanSlug {
  if (!planName || typeof planName !== 'string') return 'free';
  const n = planName.toLowerCase().trim();
  if (n === 'enterprise' || n.includes('enterprise')) return 'enterprise';
  if (n === 'rise' || n.startsWith('rise')) return 'rise';
  if (n === 'pro' || n.startsWith('pro ')) return 'pro';
  if (n === 'expert' || n.includes('expert')) return 'expert';
  if (
    n === 'free' ||
    n === 'kostenlos' ||
    n === 'ücretsiz' ||
    n === 'ucretsiz' ||
    n.includes('free')
  ) {
    return 'free';
  }
  return 'free';
}
